import { z } from 'zod'

export const holidaySchema = z.object({
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Choose a date.'),
  name: z.string().trim().min(1, 'Enter a name.').max(120, 'Use at most 120 characters.'),
  type: z.enum(['government', 'religious', 'school', 'closure'], 'Choose a type.'),
})

export type HolidayFormValues = z.infer<typeof holidaySchema>
